var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayedTicketChart)?_c('v-col',{staticClass:"pb-0 pt-0",staticStyle:{"position":"relative","height":"380px"},attrs:{"cols":"12"}}):_c('v-col',{staticClass:"pb-0 pt-0",staticStyle:{"position":"relative","height":"780px"},attrs:{"cols":"12"}})
}
var staticRenderFns = []

export { render, staticRenderFns }